import React from 'react';
import moment from 'moment';
import { CURRENCY } from '../libs/utils/Const';
var formatNumber = {
    separador: ",", // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        var splitStr = num.split('.');
        var splitLeft = splitStr[0];
        var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        var regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    }
};

const renderTableBody = (headers, data, checkbox, openDocumentDetails, view) => {
    let body = "";
    body = data.map((register, index) => {

        let docDate = new Date(register.DocDate);
        let docDueDate = new Date(register.DocDueDate);

        docDate.setMinutes(docDate.getMinutes() + docDate.getTimezoneOffset());
        docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());
        return (
            <tr key={index}>
                <td className="sticky-column" >
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
                </td>
                {headers[0].value && <td>{register.Series}</td>}
                {headers[1].value && <td className="text-right font-weight-bold">{register.DocNum}</td>}
                {headers[2].value && <td>{register.CardCode}</td>}
                {headers[3].value && <td>{register.CardName}</td>}
                {headers[4].value && <td className="text-center">{moment(docDate).format("DD-MM-YYYY")}</td>}
                {headers[5].value && (<td className={`text-center ${register.Canceled === 'Y' ? 'text-danger' : 'text-success'}`}>{register.Canceled === 'Y' ? "Sí" : "No"}</td>)}
                {headers[6].value && <td>{register.relatedInvoices || ''}</td>}
                {headers[7].value && <td>{!register.Comments ? "No hay comentarios" : register.Comments}</td>}
                {headers[8].value && <td className="text-right font-weight-bold">{CURRENCY + formatNumber.new(register.DocTotal === 0 || register.DocTotal <= '0' || register.DocTotal === null || register.DocTotal === 'undefined' || register.DocTotal === undefined || register.DocTotal === NaN || register.DocTotal === "" ? "0.00" : register.DocTotal)}</td>}
                {headers[9].value && <td>{register.U_STR_ObsEst || ''}</td>}
                {headers[10].value && <td>{register.U_STR_Estado || ''}</td>}
                <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }} >
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect" onClick={() => openDocumentDetails({ DocEntry: register.DocEntry, index })} style={{ fontWeight: '500' }}>
                        <i className="far fa-file-alt"></i> Ver Detalles
                    </button>
                </td>
            </tr>
        )
    })
    return body;
};

const renderTable = (headers, data, checkbox, openDocumentDetails, view) => {
    let header = "";
    let body = "";
    header = <tr>
        <td className="sticky-column" style={{ backgroundColor: "#e9ecef" }} >
            <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" value="second_checkbox" onChange={(event) => checkbox.selectAll(event.target.checked)} />
        </td>
        {headers[0].value && <td>{headers[0].title}</td>}
        {headers[1].value && <td>{headers[1].title}</td>}
        {headers[2].value && <td>{headers[2].title}</td>}
        {headers[3].value && <td>{headers[3].title}</td>}
        {headers[4].value && <td>{headers[4].title}</td>}
        {headers[5].value && <td>{headers[5].title}</td>}
        {headers[6].value && <td>{headers[6].title}</td>}
        {headers[7].value && <td>{headers[7].title}</td>}
        {headers[8].value && <td>{headers[8].title}</td>}
        {headers[9].value && <td>{headers[9].title}</td>}
        {headers[10].value && <td>{headers[10].title}</td>}
        {/* {headers[9].value && <td>{headers[9].title}</td>}
            {headers[10].value && <td>{headers[10].title}</td>}
            {headers[11].value && <td>{headers[11].title}</td>}
            {headers[12].value && <td>{headers[12].title}</td>}
            {headers[13].value && <td>{headers[13].title}</td>} */}
        <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

    </tr>;
    body = renderTableBody(headers, data, checkbox, openDocumentDetails, view);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderTableIncomingPayment = (headers, data, checkbox, openDocumentDetails, view) => {
    return renderTable(headers, data, checkbox, openDocumentDetails, view);
}
